import { ResourcesManager, ResourceType, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Box3, Mesh, MeshBasicMaterial, Object3D, Vector3 } from 'three';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { MaterialImprovement } from '../../../utils/MaterialImprovement';
export class TestTubesHolder extends ViewerModule {
    constructor() {
        super();
        this.placeholderPositions = [
            new Vector3(0, 0.14468345793910295, -0.45214306674588645),
            new Vector3(0, 0.14468345793910295, -0.009885567441016596),
            new Vector3(0, 0.14468345793910295, 0.4482112510093502)
        ];
        this.resourcesInUse.push({
            name: 'tt_stand_3',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/tt_stand_3.fbx')
        }, {
            name: 'test_tube_empty',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/test_tube_empty.fbx')
        });
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = ResourcesManager.getModel('tt_stand_3').clone());
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'tt_stand_3');
        this.testTubePlaceholderObjects = this.placeholderPositions.map(position => {
            let testTube = this.addObject(new Object3D());
            const testTubeEmpty = ResourcesManager.getModel('test_tube_empty');
            MaterialImprovement.upgradeMaterialsFromModel(testTubeEmpty, 'test_tube_empty');
            const fakeTestTube = this.addObject(this.generatePlaceholderObject(testTubeEmpty), null, testTube);
            fakeTestTube.visible = false;
            testTube.position.copy(position);
            return testTube;
        });
    }
    generatePlaceholderObject(object) {
        const newObject = deepClone(object);
        newObject.traverse(obj => {
            if (obj instanceof Mesh) {
                obj.material = new MeshBasicMaterial({ wireframe: true, color: 'green' });
            }
        });
        return newObject;
    }
    getPlaceholders(dragndropGroup) {
        dragndropGroup.on('drag_started', () => {
            this.testTubePlaceholderObjects.forEach(object => object.children[0].visible = object.children.length <= 1); // Setting fake test visible
        });
        dragndropGroup.on('drag_ended', () => {
            this.testTubePlaceholderObjects.forEach(object => object.children[0].visible = false); // Setting fake test invisible
        });
        return this.testTubePlaceholderObjects.map((object, i) => dragndropGroup.addPlaceholder(object, new Box3(), `placeholderTestTube${i}`));
    }
}
